import { Link } from "react-router-dom";
import { classNames } from "primereact/utils";
import localeText from "../../../../../locale";

const ITEMS = [
  { key: "bankTransfers", icon: "pi pi-money-bill", to: "/dashboard-banktransfers" },
  { key: "pendingOrders", icon: "pi pi-exclamation-circle", to: "/dashboard-pendings" },
  { key: "withdrawRequests", icon: "pi pi-arrow-circle-up", to: "/dashboard-listwithdrawrequests" },
  { key: "bangoodOrders", icon: "pi pi-globe", to: "/dashboard-bangood" },
  { key: "physicalStores", icon: "pi pi-building", to: "/dashboard-listphysicalstores" },
];

const LABEL_KEYS = {
  bankTransfers: "adminHomePendingBankTransfers",
  pendingOrders: "adminHomePendingOrders",
  withdrawRequests: "adminHomePendingWithdraws",
  bangoodOrders: "adminHomePendingBangood",
  physicalStores: "adminHomePendingPhysicalStores",
};

const renderCount = (count) => {
  if (count === null) return <span className="admin-home-skeleton admin-home-skeleton--count" />;
  if (count === undefined) return <span className="admin-home-attention__count">—</span>;
  return <span className="admin-home-attention__count">{count}</span>;
};

const AttentionPanel = ({ counts }) => {
  const loaded = Object.values(counts).every((count) => count !== null);
  const totalPending = Object.values(counts).reduce((sum, count) => sum + (count || 0), 0);

  return (
    <section className="admin-home-card admin-home-attention">
      <header className="admin-home-card__header">
        <div>
          <h2 className="admin-home-card__title">{localeText("adminHomeNeedsAttention")}</h2>
          <p className="admin-home-card__subtitle">{localeText("adminHomeNeedsAttentionHint")}</p>
        </div>
        {loaded && totalPending === 0 && (
          <span className="admin-home-status admin-home-status--good">
            <i className="pi pi-check-circle" aria-hidden="true" />
            {localeText("adminHomeAllClear")}
          </span>
        )}
      </header>

      <ul className="admin-home-attention__list">
        {ITEMS.map((item) => {
          const count = counts[item.key];
          const pending = count > 0;
          return (
            <li key={item.key}>
              <Link
                to={item.to}
                className={classNames("admin-home-attention__item", {
                  "admin-home-attention__item--pending": pending,
                })}
              >
                <span className="admin-home-attention__icon">
                  <i className={item.icon} aria-hidden="true" />
                </span>
                <span className="admin-home-attention__label">
                  {localeText(LABEL_KEYS[item.key])}
                </span>
                {renderCount(count)}
                <i className="pi pi-angle-right admin-home-attention__arrow" aria-hidden="true" />
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default AttentionPanel;
